export default __webpack_public_path__ + "static/media/media.21be330a.svg";